import { AxiosError } from 'axios'
import { ENDPOINT_PROJECT_SETTINGS } from '../config'
import type { ProjectStatusModeResponse } from '../types'
import AuthAxios from '@/lib/api/axios/AuthAxios'

/**
 * Enable advanced status management for a specific project.
 *
 * Backend: `POST /api/v1.0/e/{workspaceSlug}/projects/{projectId}/settings/enable-advanced-status-management`
 * Flips Project.StatusMode to "advanced" server-side. The client should NOT also
 * write statusMode via RxDB — the projects sync push treats the field as read-only.
 */
const enableProjectAdvancedStatus = async (
  workspaceSlug: string,
  projectId: string,
): Promise<ProjectStatusModeResponse> => {
  try {
    const response = await AuthAxios.post<ProjectStatusModeResponse>(
      `${ENDPOINT_PROJECT_SETTINGS}/${workspaceSlug}/projects/${projectId}/settings/enable-advanced-status-management`,
    )
    return response.data
  } catch (error) {
    if (error instanceof AxiosError && error.response?.status === 403) {
      throw new Error('You do not have permission to change status mode for this project')
    }
    throw error
  }
}

export default enableProjectAdvancedStatus
